import { MediaSummaryCard, type MediaSummaryView } from '../MediaSummaryCard/MediaSummaryCard';
import type { WidgetBlockProps } from '../shared/cardShell';

export type MediaNegativeMentionsCardProps = WidgetBlockProps & { view?: MediaSummaryView };

/** Figma `2123:83789` — `negativeMentions` over coverage rows. */
export function MediaNegativeMentionsCard(props: MediaNegativeMentionsCardProps) {
  return (
    <MediaSummaryCard
      {...props}
      title="Negative mentions"
      helpText="Published media stories classified as negative toward your brand during the selected period."
    />
  );
}
